import { background } from "@/theme/colors";
import { Stack, StackProps, styled } from "@mui/material";
import { FC } from "react";

type TStickyFooterProps = StackProps;

export const StickyFooter: FC<TStickyFooterProps> = ({ children, ...rest }) => {
  return (
    <StyledFooter direction="row" alignItems="center" gap={2} py={2} px={3} {...rest}>
      {children}
    </StyledFooter>
  );
};

const StyledFooter = styled(Stack)`
  position: sticky;
  bottom: 0;
  left: 0;
  background: ${background.white};
  z-index: 99;
  border-radius: 8px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);
`;
